import { callApiV2 } from "@/lib/config/Api";
import {
	InvoiceCollectionJson,
	InvoiceJson,
	InvoicePublicJson,
} from "@/types/Invoice.type";

const URL_MY_ORDER = "/orders/cart/myoder";

export const getInvoiceDetailsPublic = async (code: string) => {
	const response = await callApiV2<InvoiceJson>(
		`/orders/public/invoice/code/${code}`,
		"get"
	);

	return response;
};
export const getInvoiceDetailsById = async (id: string) => {
	const response = await callApiV2<InvoiceJson>(
		`/orders/public/invoice/token/${id}`,
		"get"
	);

	return response;
};
export const getInvoiceDetailsUser = async (id: number | string) => {
	const response = await callApiV2<InvoiceJson>(`/orders/invoice/${id}`, "get");

	return response;
};
export const getInvoiceDetailsUserByCode = async (code: string) => {
	const response = await callApiV2<InvoiceJson>(
		`/orders/invoice/code/${code}`,
		"get"
	);

	return response;
};
export const getInvoiceList = async (params?: any) => {
	const response = await callApiV2<InvoiceCollectionJson>(URL_MY_ORDER, "get", {
		params: params,
	});

	return response;
};
